import { css } from "@emotion/css";

import { Theme } from "@/modules/theme/utils/createTheme";

export const createChangePasswordSuccessPageStyles = ({
  spacing,
  palette,
}: Theme) => {
  return {
    contentWrapper: css({
      textAlign: "center",
      marginBottom: spacing(10),
      padding: spacing([0, 2]),
    }),
    heading: css({
      color: palette.default.text,
    }),
    description: css({
      marginTop: spacing(1),
    }),
    loaderWrapper: css({
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      marginTop: spacing(3),
    }),
    loader: css({
      marginBottom: spacing(1),
    }),
  };
};
